
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

import Loading from "@/components/shared/Loading.vue";
import EventBus from "@/components/shared/EventBus.vue";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";

import { QUERY_GET_COMMENT_BY_ID, MUTATION_EDIT_COMMENT } from "./graphql";

import axios from "axios";
import { Comment, ModerationEnum } from "@/types";

@Component({ components: { Loading, ConfirmDialog } })
export default class CommentForm extends Vue {
  comment: Comment | null = null;
  formRules: any = {
    required: [(v: number) => !!v || "Field is required"],
    requiredNumber: [(v: number) => v >= 0 || "Must be greater than 0"]
  };

  formIsValid: boolean = false;

  formTitle: string = "";

  loading: boolean = false;

  confirmDialogIsOpen: boolean = false;

  previewImageUrl: string | null = null;

  vueAppAdminUrl: string = "";

  get commentId(): string {
    const { commentId = "" } = this.$route.params;
    return commentId;
  }

  get isEditMode(): boolean {
    return this.commentId !== "";
  }

  get form(): any {
    return this.$refs.form;
  }

  async mounted() {
    this.loading = true;

    await this.fetchComment();

    this.loading = false;
  }

  async fetchComment() {
    if (!this.isEditMode) return;

    try {
      const { data } = await this.$apollo.query({
        query: QUERY_GET_COMMENT_BY_ID,
        variables: { commentId: this.commentId }
      });

      if (!data && data.comment !== null) {
        throw new Error("Unable to find comment");
      }
      this.comment = data.comment;
      this.formTitle = data.comment.author.email || "";

      EventBus.$emit("handleAddToBreadcrumb", [{ label: this.formTitle }]);
    } catch (err) {
      this.$store.commit("setSnackMessageWithColor", {
        message: err,
        color: "error"
      });
      this.$router.push({ name: "comments" });
    }
  }

  handleBackClick() {
    this.$router.push({ name: "comments" });
  }

  async handleOnDelete() {
    this.loading = true;

    const res = await this.$confirm(
      "Voulez-vous rééelement supprimé le commentaire ?",
      { title: "Warning" }
    );

    if (res) {
      try {
        const { data } = await this.$apollo.mutate({
          mutation: MUTATION_EDIT_COMMENT,
          variables: {
            comment: { id: this.commentId, moderation: ModerationEnum.DELETED }
          }
        });

        this.$store.commit("setSnackMessageWithColor", {
          message: "Comment was deleted",
          color: "success"
        });

        this.$router.push({ name: "comments" });
      } catch (err) {
        this.$store.commit("setSnackMessageWithColor", {
          message: err,
          color: "error"
        });
      }
    }

    this.loading = false;
  }

  async handleOnUpdate(close: boolean) {
    if (!this.form.validate()) return;
    this.loading = true;

    try {
      this.$store.commit("setSnackMessageWithColor", {
        message: "Comment informations was saved successfully",
        color: "success"
      });

      if (close) {
        this.$router.push({ name: "comments" });
        return;
      }
    } catch (err) {
      this.$store.commit("setSnackMessageWithColor", {
        message: err,
        color: "error"
      });
    }

    this.loading = false;
  }

  isDeleted() {
    return this.comment
      ? this.comment.moderation === ModerationEnum.DELETED
      : false;
  }

  isBlocked() {
    return this.comment
      ? this.comment.moderation === ModerationEnum.BLOQUED
      : false;
  }

  isPending() {
    return this.comment
      ? this.comment.moderation === ModerationEnum.PENDING
      : false;
  }

  isValid() {
    return this.comment
      ? this.comment.moderation === ModerationEnum.VALID
      : false;
  }

  async handleOnBlock() {
    this.loading = true;
    try {
      const { data } = await this.$apollo.mutate({
        mutation: MUTATION_EDIT_COMMENT,
        variables: {
          comment: { id: this.commentId, moderation: ModerationEnum.BLOQUED }
        }
      });

      this.$store.commit("setSnackMessageWithColor", {
        message: "Comment was bloqued",
        color: "success"
      });

      this.fetchComment();
    } catch (err) {
      this.$store.commit("setSnackMessageWithColor", {
        message: err,
        color: "error"
      });
    }

    this.loading = false;
  }

  async handleOnValid() {
    this.loading = true;

    try {
      const { data } = await this.$apollo.mutate({
        mutation: MUTATION_EDIT_COMMENT,
        variables: {
          comment: { id: this.commentId, moderation: ModerationEnum.VALID }
        }
      });

      this.$store.commit("setSnackMessageWithColor", {
        message: "Comment was validated",
        color: "success"
      });

      this.fetchComment();
    } catch (err) {
      this.$store.commit("setSnackMessageWithColor", {
        message: err,
        color: "error"
      });
    }

    this.loading = false;
  }
}
